const encodeGetParams = (queryParams) =>
  Object.entries(queryParams)
    .map((kv) => kv.map(encodeURIComponent).join("="))
    .join("&");

export default encodeGetParams;
